import { CheckCircle2, AlertTriangle, XCircle } from 'lucide-react';

export const StatusPill = ({ status, showIcon = true }) => {
  const config = {
    completed: {
      bg: 'bg-emerald-100',
      text: 'text-emerald-800',
      border: 'border-emerald-200',
      icon: CheckCircle2,
      label: 'Conferido'
    },
    partial: {
      bg: 'bg-amber-100',
      text: 'text-amber-800',
      border: 'border-amber-200',
      icon: AlertTriangle,
      label: 'Parcial'
    },
    pending: {
      bg: 'bg-red-100',
      text: 'text-red-800',
      border: 'border-red-200',
      icon: XCircle,
      label: 'Pendente'
    },
    in_progress: {
      bg: 'bg-blue-100',
      text: 'text-blue-800',
      border: 'border-blue-200',
      icon: AlertTriangle,
      label: 'Em Andamento'
    },
    not_checkable: {
      bg: 'bg-slate-100',
      text: 'text-slate-600',
      border: 'border-slate-200',
      icon: XCircle,
      label: 'Sem EAN'
    }
  };

  const { bg, text, border, icon: Icon, label } = config[status] || config.pending;

  return (
    <span 
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-sm font-medium ${bg} ${text} border ${border}`}
      data-testid={`status-pill-${status}`}
    >
      {showIcon && <Icon size={14} />}
      {label}
    </span>
  );
};
